import React from "react";

const Profile = () => {

  return (
    <div className="ctn-wrp">
      h2h2
    </div>
  )
}

export default Profile